export const INIT_COMPARISON_STATE = 'INIT_COMPARISON_STATE';
export const ADD_COMPARISON_SELECTED_ITEM = 'ADD_COMPARISON_SELECTED_ITEM';
export const REMOVE_COMPARISON_SELECTED_ITEM =
    'REMOVE_COMPARISON_SELECTED_ITEM';
export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';

export const REMOVE_COMPARISON_VIEW_ITEM = 'REMOVE_COMPARISON_VIEW_ITEM';

export const GET_COMPARISON_SELECTED_REQUEST =
    'GET_COMPARISON_SELECTED_REQUEST';
export const GET_COMPARISON_SELECTED_SUCCESS =
    'GET_COMPARISON_SELECTED_SUCCESS';
export const GET_COMPARISON_SELECTED_FAILURE =
    'GET_COMPARISON_SELECTED_FAILURE';

export const GET_SELECTED_LABELS_REQUEST = 'GET_SELECTED_LABELS_REQUEST';
export const GET_SELECTED_LABELS_SUCCESS = 'GET_SELECTED_LABELS_SUCCESS';
export const GET_SELECTED_LABELS_FAILURE = 'GET_SELECTED_LABELS_FAILURE';
